export default {
  Nome: {
    label: 'fields.installation.installation-name',
  },
  Complexo: {
    label: 'fields.installation.complex',
  },
  UnidadeFederativa: {
    label: 'fields.installation.federativeUnit',
  },
  TipoInstalacao: {
    label: 'fields.installation.installation-type',
    max: 150,
  },
  Latitude: {
    label: 'fields.installation.latitude',
    min: -90,
    max: 90,
  },
  Longitude: {
    label: 'fields.installation.longitude',
    min: -180,
    max: 180,
  },
};
